import { useEffect, useState, useRef } from "react";
import { Alert, Col } from "react-bootstrap";
import { ReactComponent as CheckBoxUnselectedHover } from '../../Assets/img/CheckBoxUnselectedHover.svg';
import { ReactComponent as CheckBoxPartial } from '../../Assets/img/CheckBoxPartial.svg';
import { ReactComponent as CheckBoxPartialHover } from '../../Assets/img/CheckBoxPartialHover.svg';
import { ReactComponent as CheckBoxUnselected } from '../../Assets/img/CheckBoxUnselected.svg';
import { ReactComponent as CheckBoxSelected } from '../../Assets/img/CheckBoxSelected.svg';
import { ReactComponent as CheckBoxSelectedHover } from '../../Assets/img/CheckBoxSelectedHover.svg';
import { ReactComponent as DescendingIcon } from '../../Assets/img/DescendingIcon.svg';
import { ReactComponent as AscendingIcon } from '../../Assets/img/AscendingIcon.svg';
import { ReactComponent as DescendingHoverIcon } from '../../Assets/img/DescendingHoverIcon.svg';
import { ReactComponent as AscendingHoverIcon } from '../../Assets/img/AscendingHoverIcon.svg';
import { ReactComponent as Edit } from '../../Assets/img/EditPen.svg';
import { ReactComponent as EditPenHover } from '../../Assets/img/EditPenHover.svg';
import { ReactComponent as Show } from '../../Assets/img/Show.svg';
import { ReactComponent as Hide } from '../../Assets/img/Hide.svg';
import { ModalFooter } from 'react-bootstrap';
import ReactPopup from 'reactjs-popup';
import { CSVLink } from "react-csv";
import { createColumnHelper, flexRender, getCoreRowModel, useReactTable, } from '@tanstack/react-table';

import DeviceService from "../../Services/DeviceService";
import LoadingIndicator from "../CommonComponent/LoadingIndicator";
import NoMatch from "../CommonComponent/NoMatch";
import Footer from "../FooterComponent/Footer";
import PageTable from "../PageComponent/PageTable";
import PageTop from "../PageComponent/PageTop";
import MessagePopup from "../PopupComponent/MessagePopup";
import WarningMessagePopup from "../PopupComponent/WarningMessagePopup";
import AddDeviceModel from "../DeviceModelComponent/AddDeviceModel";
import EditDeviceModel from "../DeviceModelComponent/EditDeviceModel";
import Navigation from "../NavigationComponent/Navigation";
import TopNavigation from "../NavigationComponent/TopNavigation";
import TextFilterBox from "../PopupComponent/TextFilterBox";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../Assets/css/bootstrap.css";

const columnHelper = createColumnHelper();
const columns = [columnHelper.accessor('Model', {
    cell: info => <span style={{ width: info.column.getSize() }}>{info.getValue()}</span>,
    header: info => <span style={{ width: info.column.getSize() }}>Model</span>,
    id: "Model",
    meta: {
        sortFieldName: "Model",
        type: "string"
    },
    size: 225
}), columnHelper.accessor('Make', {
    cell: info => <span style={{ width: info.column.getSize() }}>{info.getValue()}</span>,
    header: info => <span style={{ width: info.column.getSize() }}>Make</span>,
    id: "Make",
    meta: {
        sortFieldName: "Make",
        type: "string"
    },
    size: 225
})];

/**
 * Renders device Model page with all the device models functions
 * @component
 */
function DeviceModel() {

    //#region States

    const [state, setState] = useState({
        status: "LOADING",
        deviceModels: null,
        error: null,
        deviceModelId: "",
        perPage: 20,
        currentPage: 0,
        pageCount: 0,
        totalDataCount: 0,
        sortField: null,
        sortType: null,
        selectedItems: [],
        showFilter: false,
        allColumnFilter: null,
        deviceMakeFilter: null,
        deviceModelFilter: null,
        searchDeviceMake: "",
        searchDeviceModel: "",
        isTableLoading: false,
        model: null,
        success: null,
        message: null,
        hiddenColumns: [],
        allDeviceModels: [],
        selectedItemsForPopup: [],
        triggerCSVDownload: false
    });

    //#endregion

    //#region Refs

    const searchValue = useRef();
    const csvRef = useRef();

    const [data, setData] = useState([]);

    const table = useReactTable({
        data,
        columns,
        columnResizeMode: "onChange",
        getCoreRowModel: getCoreRowModel(),
    });

    //#endregion

    //#region CSV headers

    const csvHeader = [
        { label: "Make", key: "Make" },
        { label: "Model", key: "Model" }
    ];

    //#endregion

    //#region useEffect hook

    /**
    * Calls loadDeviceModels() method to get device models
    * Runs on state change of state.currentPage, state.perPage, state.sortField, state.sortType, state.allColumnFilter, state.deviceMakeFilter, state.deviceModelFilter
    */
    useEffect(() => {
        async function fetchData() {
            await loadDeviceModels();
        }
        fetchData();
    }, [state.currentPage, state.perPage, state.sortField, state.sortType, state.allColumnFilter, state.deviceMakeFilter,
    state.deviceModelFilter]);

    /**
   * Calls loadDeviceModels() method to get device models on successfull execution of device service methods
   * Runs only on state change of state.success
   */
    useEffect(() => {
        async function fetchData() {
            await loadDeviceModels();
        }
        if (state.success == true) {
            fetchData();
        }
    }, [state.success]);

    useEffect(() => {
        if (state.triggerCSVDownload) {
            csvRef.current.link.click();
            setState((currentState) => ({
                ...currentState,
                triggerCSVDownload: false
            }));
        }
    }, [state.triggerCSVDownload])

    //#endregion

    //#region Device Model functions

    /**
    * Calls device service to fetch device models according to device model filters
    */
    const loadDeviceModels = async () => {
        setState((currentState) => ({
            ...currentState,
            isTableLoading: true,
        }));

        try {
            var request = {
                Filters: [state.allColumnFilter, state.deviceMakeFilter,
                state.deviceModelFilter].filter(f => f != null),
                Sort: (state.sortField == null || state.sortType == null) ? [] : [{
                    SortField: state.sortField,
                    sortType: state.sortType
                }],
                Pagination: {
                    PageStart: state.currentPage,
                    PageFetch: state.perPage
                }
            }
            const response = await DeviceService.GetDeviceModelsPerPage(request);

            var responseD = [];
            response.Data.forEach((deviceModel) => {
                responseD.push({
                    "Model": deviceModel.Model,
                    "Make": deviceModel.Make
                })
            })
            setData(responseD);

            console.log(response);

            setState((currentState) => ({
                ...currentState,
                status: 'LOADED',
                isTableLoading: false,
                deviceModels: response.Data,
                pageCount: Math.ceil(
                    response.TotalRecord / state.perPage
                ),
                totalDataCount: response.TotalRecord
            }));
        } catch (error) {
            setState((currentState) => ({
                ...currentState,
                status: 'ERROR',
                error: error
            }));
        }
    };

    /**
    * Calls device service to fetch all device models
    */
    const getAllDeviceModels = async () => {
        DeviceService.GetDeviceModels().then((deviceModels) => {
            setState((currentState) => ({
                ...currentState,
                allDeviceModels: deviceModels.response,
                triggerCSVDownload: true
            }));
        }).catch((error) => {
            setState((currentState) => ({
                ...currentState,
                status: "ERROR",
                error: error,
            }));
        });
    }

    /**
   * Move to next page
   */
    const nextPageHandler = () => {
        if (state.currentPage + 2 > state.pageCount) {
            return;
        }
        setState((currentState) => ({
            ...currentState,
            currentPage: currentState.currentPage + 1,
            selectedItems: []
        }));
    }

    /**
   * Move to previous page
   */
    const previousPageHandler = () => {
        if (state.currentPage - 1 < 0) {
            return;
        }
        setState((currentState) => ({
            ...currentState,
            currentPage: currentState.currentPage - 1,
            selectedItems: []
        }));
    }

    /**
    * Move to first page
    */
    const firstPageHandler = () => {
        if (state.currentPage == 0) {
            return;
        }
        setState((currentState) => ({
            ...currentState,
            currentPage: 0,
            selectedItems: []
        }));
    }

    /**
    * Move to last page
    */
    const lastPageHandler = () => {
        if (state.currentPage == state.pageCount - 1) {
            return;
        }
        setState((currentState) => ({
            ...currentState,
            currentPage: currentState.pageCount - 1,
            selectedItems: []
        }));
    }

    /**
   * Sort the given field  ("asc" to "desc", "desc" to "asc", null to "asc")
   * @param   {String} field  Coloumn name that user wants to change
   */
    const sort = (field) => {
        var type = state.sortType;
        var fieldValue = state.sortField;
        if (type == null) {
            type = "asc";
        }
        else if (type == "asc") {
            if (fieldValue == field) {
                type = "desc";
            }
            else {
                type = "asc";
            }
        }
        else {
            if (fieldValue == field) {
                type = null;
            }
            else {
                type = "asc";
            }
        }

        setState((currentState) => ({
            ...currentState,
            sortField: field,
            sortType: type,
            selectedItems: []
        }));
    }

    /**
    * Push the device model into the list of selected device models
    * @param   {Object} deviceModel  Object that contains Id,Make,Model
    */
    const selectItem = (deviceModel) => {
        var selected = state.selectedItems;
        selected.push(deviceModel);
        setState((currentState) => ({
            ...currentState,
            selectedItems: selected
        }));
    }

    /**
    * Remove the device model from the list of selected device models
    * @param   {Object} deviceModel  Object that contains Id,Make,Model
    */
    const unSelectItem = (deviceModel) => {
        var selected = state.selectedItems.filter(sel => sel != deviceModel);
        setState((currentState) => ({
            ...currentState,
            selectedItems: selected
        }));
    }

    /**
    * Push all the device models into the list of selected device model
    */
    const selectAllItems = () => {
        var selected = [];
        state.deviceModels.forEach(deviceModel => {
            selected.push(deviceModel);
        });
        setState((currentState) => ({
            ...currentState,
            selectedItems: selected
        }));
    }

    /**
    * Remove all the device models from the list of selected device model
    */
    const unSelectAllItems = () => {
        setState((currentState) => ({
            ...currentState,
            selectedItems: []
        }));
    }

    /**
   * Changes the number of device model per page according to user input
   * @param    {Event} event  User action (on changing value)
   */
    const changePerPage = (event) => {
        setState((currentState) => ({
            ...currentState,
            perPage: event.target.value,
            currentPage: 0,
            selectedItems: []
        }));
    }

    /**
    * Search device Model
    */
    const searchAllColumn = () => {
        if (searchValue.current.value == "") {
            setState((currentState) => ({
                ...currentState,
                allColumnFilter: null
            }));
        }
        else {
            setState((currentState) => ({
                ...currentState,
                allColumnFilter: {
                    Type: "contains",
                    Value: searchValue.current.value,
                    ColumnNames: ["make", "model"]
                }
            }));
        }
    }

    /**
   * Search device model by make
   * @param    {Event} event  User action (on changing value)
   */
    const searchByDeviceMake = (event) => {
        setState((currentState) => ({
            ...currentState,
            searchDeviceMake: event.target.value
        }));
        var filter;
        if (event.target.value == "") {
            filter = null;
        }
        else {
            filter = {
                ColumnNames: ["make"],
                Type: "contains",
                Value: event.target.value
            };
        }
        setState((currentState) => ({
            ...currentState,
            deviceMakeFilter: filter
        }));
    }

    /**
   * Search device model by model
   * @param    {Event} event  User action (on changing value)
   */
    const searchByDeviceModel = (event) => {
        setState((currentState) => ({
            ...currentState,
            searchDeviceModel: event.target.value
        }));
        var filter;
        if (event.target.value == "") {
            filter = null;
        }
        else {
            filter = {
                ColumnNames: ["model"],
                Type: "contains",
                Value: event.target.value
            };
        }
        setState((currentState) => ({
            ...currentState,
            deviceModelFilter: filter
        }));
    }

    /**
  * Clear all the applied filters
  */
    const clearFilters = () => {
        setState((currentState) => ({
            ...currentState,
            deviceMakeFilter: null,
            deviceModelFilter: null,
            searchDeviceMake: "",
            searchDeviceModel: ""
        }))
    }

    /**
   * Reset the page to default
   */
    const resetPage = () => {
        setState((currentState) => ({
            ...currentState,
            status: "LOADED",
            error: null,
            deviceModelId: "",
            perPage: 20,
            currentPage: 0,
            sortField: null,
            sortType: null,
            selectedItems: [],
            showFilter: false,
            allColumnFilter: null,
            deviceMakeFilter: null,
            deviceModelFilter: null,
            searchDeviceMake: "",
            searchDeviceModel: "",
            isTableLoading: false,
            model: null,
            success: null,
            message: null,
            hiddenColumns: [],
            allDeviceModels: [],
            selectedItemsForPopup: []
        }));
        searchValue.current.value = ""
        table.getHeaderGroups().map((headerGroup) => (
            headerGroup.headers.map((header) => (
                header.column.resetSize()
            ))
        ))
    }

    /**
   * Show the selected column in device models table
   * @param    {String} columnName  Column name that user selected to show
   */
    const showColumn = (columnName) => {
        if (columnName == "") {
            setState((currentState) => ({
                ...currentState,
                hiddenColumns: []
            }));
        }

        var columns = state.hiddenColumns.filter(c => c != columnName);

        setState((currentState) => ({
            ...currentState,
            hiddenColumns: columns
        }));
    }

    /**
   * Hide the selected column from device models table
   * @param    {String} columnName  Column name that user selected to hide
   */
    const hideColumn = (columnName) => {
        var columns = state.hiddenColumns;
        columns.push(columnName);

        setState((currentState) => ({
            ...currentState,
            hiddenColumns: columns
        }));
    }

    /**
   * Show all the columns in device models table
   */
    const showAllColumns = () => {
        setState((currentState) => ({
            ...currentState,
            hiddenColumns: []
        }));
    }

    /**
  * Deletes all the selected device Model
  */
    const DeleteDeviceModels = async () => {
        try {
            var Ids = [];
            state.selectedItems.forEach(d => Ids.push(d.Id));
            var request = {
                Ids: Ids
            }
            await DeviceService.BulkDeleteDeviceModels(request);

            setState((currentState) => ({
                ...currentState,
                selectedItems: [],
                model: null,
                success: true,
                message: "Device Models deleted",
            }));
        } catch (error) {
            setState((currentState) => ({
                ...currentState,
                status: "ERROR",
                error: error,

            }));
        }
    };

    /**
  * Opens model
  * @param    {String} model  Name of model to open
  * @param    {String} param  Value of parameter corresponding to model
  */
    const modelOpenHandler = (model, param) => {
        if (model == "edit") {
            setState((currentState) => ({
                ...currentState,
                deviceModelId: param
            }));
        }

        setState((currentState) => ({
            ...currentState,
            model: model
        }));
    }

    /**
  * Closes opened model
  */
    const modelCloseHandler = async () => {
        setState((currentState) => ({
            ...currentState,
            model: null
        }));
    }

    /**
   * Display message
   * @param    {String} message  Message needs to be displayed
   */
    const messageDisplayHandler = async (message) => {
        setState((currentState) => ({
            ...currentState,
            selectedItems: [],
            selectedItemsForPopup: [],
            success: true,
            message: message
        }));
    }

    /**
  * Closes message popup
  */
    const messagePopupCloseHandler = () => {
        setState((currentState) => ({
            ...currentState,
            selectedItems: [],
            selectedItemsForPopup: [],
            success: null,
            message: null
        }));
    }

    //#endregion

    return (
        <>
            {state.status == "LOADING" && <LoadingIndicator size="large" message="Fetching..." />}
            {state.status == "ERROR" && (state.error?.message?.indexOf("404") > -1 ? <NoMatch /> : <Alert variant="danger">{state.error?.message}</Alert>)}
            {state.status == "LOADED" &&
                <>
                    <Navigation />
                    <TopNavigation onPageReset={loadDeviceModels} />
                    <div className="page-container">
                        {state.success && <MessagePopup onClose={messagePopupCloseHandler} title="Success" body={<div className="message-popup-container-body"> {state.message}
                            {state.selectedItemsForPopup.length != 0 &&
                                <table className="popup-table">
                                    <tr>
                                        <th className="warning-message-popup-first">Make</th>
                                        <th className="warning-message-popup-last">Model</th>
                                    </tr>
                                    <tbody className="popup-tbody"> {state.selectedItemsForPopup?.slice(0, 3).map(deviceModels => (
                                        <tr>
                                            <td className="warning-message-popup-first">
                                                {deviceModels.Make}
                                            </td>
                                            <td className="warning-message-popup-last">
                                                {deviceModels.Model}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                    <div className="bottom-title">
                                        {state.selectedItemsForPopup?.length > 3 && <p>... and {state.selectedItemsForPopup.length - 3} more {state.selectedItemsForPopup.length - 3 == 1 ? 'record' : 'records'}. </p>}
                                    </div>
                                </table>}
                        </div>} />}
                        {state.model == "add" && <AddDeviceModel onShowMessage={messageDisplayHandler} onClose={modelCloseHandler} action="Yes" />}
                        {state.model == "edit" && <EditDeviceModel onShowMessage={messageDisplayHandler} onClose={modelCloseHandler} action="Yes" deviceModelId={state.deviceModelId} />}
                        {state.model == "delete" && <WarningMessagePopup largeModal onClose={modelCloseHandler} title="Delete Device Models" body={<div className="message-popup-container-body"> Do you want to Delete :
                            {state.selectedItems != null &&
                                <table className="popup-table">
                                    <tr>
                                        <th className="warning-message-popup-first">Make</th>
                                        <th className="warning-message-popup-last">Model</th>
                                    </tr>
                                    <tbody className="popup-tbody"> {state.selectedItems?.slice(0, 3).map(deviceModels => (
                                        <tr>
                                            <td className="warning-message-popup-first">
                                                {deviceModels.Make}
                                            </td>
                                            <td className="warning-message-popup-last">
                                                {deviceModels.Model}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                    <div className="bottom-title">
                                        {state.selectedItems?.length > 3 && <p>... and {state.selectedItems.length - 3} more {state.selectedItems.length - 3 == 1 ? 'record' : 'records'} ? </p>}
                                    </div>
                                </table>}
                        </div>} action="Yes" onAction={DeleteDeviceModels} />}
                        <PageTop searchPlaceholder="Search Device Models"
                            disableUploadButton
                            disableSecondAddButton
                            addButtonText="Add Device Model"
                            searchRef={searchValue}
                            showFilter={state.showFilter}
                            modelOpenHandler={modelOpenHandler}
                            searchAllColumnHandler={searchAllColumn}
                            resetPageHandler={resetPage}
                            filterColumnHandler={() => {
                                setState((currentState) => ({ ...currentState, showFilter: !currentState.showFilter }));
                                if (state.showFilter) {
                                    clearFilters();
                                }
                            }}
                            menuData={<div className="menu-popup-container">
                                <span className="bold-underline-text" onClick={() => {
                                    showAllColumns();
                                }}>
                                    ShowAll
                                </span>
                                <div className="columns-container">
                                    {table.getHeaderGroups().map(headerGroup => (
                                        headerGroup.headers.map(header => (
                                            <div className="column-container">
                                                <span className="column-text">{header.column.columnDef.accessorKey}</span>
                                                <span className="column-icon">
                                                    {state.hiddenColumns?.includes(header.id) ?
                                                        <Hide onClick={() => {
                                                            showColumn(header.id);
                                                        }} />
                                                        : <Show style={{ opacity: 0.5 }} onClick={() => {
                                                            hideColumn(header.id);
                                                        }} />}
                                                </span>
                                            </div>
                                        ))
                                    ))}
                                </div>
                                <div style={{ margin: "0 8px 10px 8px", borderTop: "1px solid #ddd" }}></div>
                                <div className="columns-container">
                                    <div className="bottom-column-container">
                                        {state.deviceModels.length === 0 ?
                                            (<span className="bottom-column-text" style={{ opacity: 0.5 }}>
                                                Export All...
                                            </span>) :
                                            (<>
                                                <span className="bottom-column-text" onClick={getAllDeviceModels} style={{ cursor: "pointer", maxWidth: "fit-content" }}>Export All...</span>
                                                <CSVLink
                                                    data={state.allDeviceModels}
                                                    headers={csvHeader}
                                                    separator={","}
                                                    filename={"DeviceModel.csv"}
                                                    asyncOnClick={true}
                                                    ref={csvRef} target="_blank" ></CSVLink>
                                            </>
                                            )}
                                    </div>
                                    <div className="bottom-column-container">
                                        {state.selectedItems.length === 0 ?
                                            (<span className="bottom-column-text" style={{ opacity: 0.5 }}>
                                                Export Selected...
                                            </span>) :
                                            (<span>
                                                <CSVLink className="bottom-column-text"
                                                    data={state.selectedItems}
                                                    headers={csvHeader}
                                                    separator={","}
                                                    filename={"DeviceModel.csv"}>
                                                    Export Selected...
                                                </CSVLink>
                                            </span>)}
                                    </div>
                                </div>
                            </div>} />
                        <PageTable isTableLoading={state.isTableLoading}
                            tableData={
                                <table>
                                    <thead className="table-header">
                                        <tr class="normal-header">
                                            <th scope="col" style={{ padding: "0 5px 0 5px" }}>
                                                {state.selectedItems.length == 0 ?
                                                    <Col className="menu-icon-container">
                                                        <CheckBoxUnselected onClick={selectAllItems} />
                                                        <CheckBoxUnselectedHover className="hover-icon" onClick={selectAllItems} />
                                                    </Col>
                                                    :
                                                    (state.selectedItems.length == state.deviceModels.length ?
                                                        <Col className="menu-icon-container">
                                                            <CheckBoxSelected onClick={unSelectAllItems} />
                                                            <CheckBoxSelectedHover className="hover-icon" onClick={unSelectAllItems} />
                                                        </Col> :
                                                        <Col className="menu-icon-container">
                                                            <CheckBoxPartial onClick={selectAllItems} />
                                                            <CheckBoxPartialHover className="hover-icon" onClick={selectAllItems} />
                                                        </Col>)}
                                            </th>
                                            {table.getHeaderGroups().map(headerGroup => (
                                                headerGroup.headers.map(header => (
                                                    !state.hiddenColumns.includes(header.id) &&
                                                    <th key={header.id} scope="col"
                                                        style={{ width: header.getSize(), cursor: "pointer", textAlign: header.column.columnDef.meta.type == "date" ? "right" : (header.column.columnDef.meta.type == "bool" ? "center" : "left") }}>
                                                        <div className="header-text-wrapper" onClick={() => { sort(header.column.columnDef.meta.sortFieldName) }}>
                                                            {state.sortField == header.column.columnDef.meta.sortFieldName && state.sortType == "asc" ?
                                                                <div className={`${header.column.columnDef.meta.type == "date" ? 'sort-icon-left' : 'sort-icon-right'}`}>
                                                                    <DescendingIcon />
                                                                    <AscendingHoverIcon />
                                                                </div> : (state.sortField == header.column.columnDef.meta.sortFieldName && state.sortType == "desc" ?
                                                                    <div className={`${header.column.columnDef.meta.type == "date" ? 'sort-icon-left' : 'sort-icon-right'}`} >
                                                                        <DescendingHoverIcon />
                                                                        <AscendingIcon />
                                                                    </div> : <div className={`${header.column.columnDef.meta.type == "date" ? 'sort-icon-left' : 'sort-icon-right'}`} >
                                                                        <DescendingIcon />
                                                                        <AscendingIcon />
                                                                    </div>)}
                                                            {header.isPlaceholder
                                                                ? null
                                                                : flexRender(
                                                                    header.column.columnDef.header,
                                                                    header.getContext()
                                                                )}
                                                        </div>
                                                        <div className={`resize-handle ${header.column.getIsResizing() ? 'active' : null}`} onMouseDown={header.getResizeHandler()} onTouchStart={header.getResizeHandler()}></div>
                                                    </th>
                                                ))
                                            ))}
                                            <th scope="col"></th>
                                        </tr>
                                        {state.showFilter &&
                                            <tr class="filter-header">
                                                <th scope="col"></th>
                                                {!state.hiddenColumns.includes("Make") &&
                                                    <th scope="col" style={{ padding: "0 5px 0 5px" }} >
                                                        <TextFilterBox clearFilterHandler={() => {
                                                            setState((currentState) => ({
                                                                ...currentState,
                                                                searchDeviceMake: "", deviceMakeFilter: null
                                                            }));
                                                        }}
                                                            searchPlaceHolder={state.searchDeviceMake}
                                                            searchHandler={searchByDeviceMake} />
                                                    </th>}
                                                {!state.hiddenColumns.includes("Model") &&
                                                    <th scope="col" style={{ padding: "0 5px 0 5px" }} >
                                                        <TextFilterBox clearFilterHandler={() => {
                                                            setState((currentState) => ({
                                                                ...currentState,
                                                                searchDeviceModel: "", deviceModelFilter: null
                                                            }));
                                                        }}
                                                            searchPlaceHolder={state.searchDeviceModel}
                                                            searchHandler={searchByDeviceModel} />
                                                    </th>}
                                                <th scope="col"></th>
                                            </tr >
                                        }
                                    </thead>
                                    {!state.isTableLoading &&
                                        <tbody >
                                            {table.getRowModel().rows.map(row => (
                                                <tr key={row.id} className={state.selectedItems.find(sel => sel.Id == state.deviceModels[row.id].Id) == null ? '' : 'selected'}>
                                                    <td scope="col">
                                                        {state.selectedItems.find(sel => sel.Id == state.deviceModels[row.id].Id) == null ?
                                                            <Col className="menu-icon-container">
                                                                <CheckBoxUnselected onClick={() => { selectItem(state.deviceModels[row.id]) }} />
                                                                <CheckBoxUnselectedHover className="hover-icon" onClick={() => { selectItem(state.deviceModels[row.id]) }} />
                                                            </Col>
                                                            :
                                                            <Col className="menu-icon-container">
                                                                <CheckBoxSelected onClick={() => { unSelectItem(state.deviceModels[row.id]) }} />
                                                                <CheckBoxSelectedHover className="hover-icon" onClick={() => { unSelectItem(state.deviceModels[row.id]) }} />
                                                            </Col>
                                                        }
                                                    </td>
                                                    {row.getVisibleCells().map(cell => (
                                                        !state.hiddenColumns.includes(cell.column.id) &&
                                                        (cell.column.columnDef.meta.type == "date" ?
                                                            <td scope="col" key={cell.id} style={{ textAlign: "right" }}>
                                                                <div className="body-text-wrapper">
                                                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                                </div>
                                                            </td> :
                                                            <td scope="col" key={cell.id}>
                                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                            </td>)
                                                    )
                                                    )}
                                                    <td scope="col">
                                                        <span className="menu-icon-container">
                                                            <Edit className="menu-icon" onClick={() => modelOpenHandler("edit", state.deviceModels[row.id].Id)} />
                                                            <EditPenHover className="menu-icon hover-icon" onClick={() => modelOpenHandler("edit", state.deviceModels[row.id].Id)} />
                                                        </span>
                                                    </td>
                                                </tr>

                                            ))}
                                        </tbody>}
                                </table>
                            } />
                        <Footer onFirstClick={firstPageHandler}
                            onLastClick={lastPageHandler}
                            onPreviousClick={previousPageHandler}
                            onNextClick={nextPageHandler}
                            perPage={state.perPage}
                            totalData={state.totalDataCount}
                            showingItemsCount={state.deviceModels.length}
                            currentPage={state.currentPage + 1}
                            totalPage={state.pageCount}
                            selectedItems={state.selectedItems.length}
                            changePerPage={changePerPage}
                            modelOpenHandler={modelOpenHandler}
                            disableEditButton
                            disableLine
                        />
                    </div>
                </>
            }
        </>
    )
}

export default DeviceModel;
